import React, { Component } from "react";
import { FiCast, FiDollarSign, FiUsers, FiMonitor } from "react-icons/fi";
import {
    Row, Col, Card, CardBody, Progress, UncontrolledTooltip, Button, Alert, FormGroup,
    Label,
    Input,
    InputGroup,
    InputGroupAddon,
    Spinner,
    UncontrolledAlert,
} from 'reactstrap';
import { withTranslation } from 'react-i18next';

const gp_wavy_check = `${process.env.PUBLIC_URL}/assets/images/gp_images/make-eco-conscious-choices-easy.webp`
const gp_circle_dollar = `${process.env.PUBLIC_URL}/assets/images/gp_images/find-and-support-certified-eco-professionals.webp`
const gp_shield_checked = `${process.env.PUBLIC_URL}/assets/images/gp_images/join-an-eco-positive-community.webp`

const ServiceList = [
    {
        //icon: <FiCast />,
        icon: <img className="service-logo-big m-0" src={gp_wavy_check} alt="conscious choices"/>,
        title: 'Make eco-conscious choices easy',
        description: ''
    },
    {
        //icon: <FiDollarSign />,
        icon: <img className="service-logo-big m-0" src={gp_circle_dollar} alt="support certified eco professionals"/>,
        title: 'Find and support certified professionals',
        description: ''
    },
    {
        //icon: <FiUsers />,
        icon: <img className="service-logo-big m-0" src={gp_shield_checked} alt="join an eco positive community"/>,
        title: 'Join an eco-positive community',
        description: ''
    }
]


class ServiceThree extends Component {
    render() {
        const { t } = this.props;
        const { column } = this.props;
        const ServiceContent = ServiceList.slice(0, this.props.item);

        return (
            <React.Fragment>
                <div className="row service-main-wrapper" style={{ backgroundColor: "#75b2ff" }}>
                    {ServiceContent.map((val, i) => (
                        <div className={`${column}`} key={i}>
                            <div className="service service__style--2 text-center align-items-center justify-content-center d-flex flex-column">
                                    {val.icon}
                                <div >
                                    <p className="item-title-medium text-center-important mt-10 text-blod-description">{t(val.title)}</p>
                                    <p className="item-description-medium text-center-important mt-10 text-gray-small">{val.description}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </React.Fragment>
        )
    }
}
export default withTranslation()(ServiceThree);
